"use client";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Html } from "@custom/schema";
import clsx from "clsx";
import React, { Fragment, useEffect, useState } from "react";
var defaultInputClasses = "text-sm border border-gray-300 rounded-md px-3 py-2 w-full";
var HubspotFormField = function(param) {
    var field = param.field, inputClass = param.inputClass, setFormData = param.setFormData, formData = param.formData, queryParams = param.queryParams;
    var handleInputChange = function(e) {
        var _e_target = e.target, name = _e_target.name, value = _e_target.value;
        // Update the state with the new form value
        setFormData(_object_spread_props(_object_spread({}, formData), _define_property({}, name, value)));
        // Show or hide help text based on field value
        field.helpHidden = Boolean(value);
    };
    // Update field value with query parameter value if exists
    if (queryParams[field.name]) {
        field.value = queryParams[field.name];
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex-1 flex flex-col justify-end", {
            hidden: field.hidden
        })
    }, field.fieldType !== "booleancheckbox" && /*#__PURE__*/ React.createElement("label", {
        className: "text-xs block w-full mb-1",
        htmlFor: field.name,
        dangerouslySetInnerHTML: {
            __html: "<span>".concat(field.label, "</span>").concat((field === null || field === void 0 ? void 0 : field.required) ? " *" : "")
        }
    }), field.description && /*#__PURE__*/ React.createElement("p", {
        className: clsx("field-help-text text-xxs text-[#888] mb-2 ", {
            hidden: field.helpHidden
        }),
        dangerouslySetInnerHTML: {
            __html: field.description
        }
    }), [
        "text",
        "email",
        "phonenumber"
    ].includes(field.fieldType) && /*#__PURE__*/ React.createElement("input", {
        className: clsx(inputClass, "text-sm", defaultInputClasses),
        id: field.name,
        name: field.name,
        type: field.name === "email" ? "email" : field.fieldType === "phonenumber" ? "tel" : field.fieldType,
        required: field.required,
        placeholder: field.placeholder,
        value: field.value,
        defaultValue: field.defaultValue,
        onChange: handleInputChange
    }), field.fieldType === "textarea" && /*#__PURE__*/ React.createElement("textarea", {
        className: clsx(inputClass, defaultInputClasses),
        id: field.name,
        name: field.name,
        required: field.required,
        placeholder: field.placeholder,
        value: field.value,
        defaultValue: field.defaultValue,
        onChange: handleInputChange
    }), field.fieldType === "select" && /*#__PURE__*/ React.createElement("select", {
        className: clsx(inputClass, defaultInputClasses),
        id: field.name,
        name: field.name,
        required: field.required,
        value: field.value,
        onChange: handleInputChange
    }, /*#__PURE__*/ React.createElement("option", {
        value: ""
    }, "Please Select"), field.options.map(function(option, index) {
        return /*#__PURE__*/ React.createElement("option", {
            key: index,
            value: option.value,
            selected: field.selectedOptions && field.selectedOptions.includes(option.value)
        }, option.label);
    })), field.fieldType === "checkbox" && /*#__PURE__*/ React.createElement("input", {
        id: field.name,
        name: field.name,
        type: "checkbox",
        onChange: handleInputChange
    }), field.fieldType === "booleancheckbox" && /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-x-4 text-xxs mb-2"
    }, /*#__PURE__*/ React.createElement("input", {
        id: field.name,
        name: field.name,
        type: "checkbox",
        onChange: handleInputChange
    }), /*#__PURE__*/ React.createElement("label", {
        className: "text-xs block w-full mb-1",
        htmlFor: field.name,
        dangerouslySetInnerHTML: {
            __html: "<span>".concat(field.label, "</span>").concat((field === null || field === void 0 ? void 0 : field.required) ? " *" : "")
        }
    })));
};
export default function HubspotForm(props) {
    var _props_metaData_find, _props_metaData, _legalConsentOptions_communicationConsentCheckboxes, _legalConsentOptions_communicationConsentCheckboxes1;
    var legalConsentMetadata = ((_props_metaData_find = (_props_metaData = props.metaData) === null || _props_metaData === void 0 ? void 0 : _props_metaData.find(function(meta) {
        return (meta === null || meta === void 0 ? void 0 : meta.name) === "legalConsentOptions";
    })) === null || _props_metaData_find === void 0 ? void 0 : _props_metaData_find.value) || undefined;
    var legalConsentOptions = legalConsentMetadata ? JSON.parse(legalConsentMetadata) : undefined;
    var _useState = _sliced_to_array(useState(false), 2), isSubmitted = _useState[0], setIsSubmitted = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), pageHref = _useState1[0], setPageHref = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), pageTitle = _useState2[0], setPageTitle = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formSubmitting = _useState3[0], setFormSubmitting = _useState3[1];
    var _useState4 = _sliced_to_array(useState((legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : legalConsentOptions.processingConsentType) == "REQUIRED_CHECKBOX" ? false : true), 2), consentToProcess = _useState4[0], setConsentToProcess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : (_legalConsentOptions_communicationConsentCheckboxes = legalConsentOptions.communicationConsentCheckboxes) === null || _legalConsentOptions_communicationConsentCheckboxes === void 0 ? void 0 : _legalConsentOptions_communicationConsentCheckboxes.map(function(checkbox) {
        return {
            subscriptionTypeId: "".concat(checkbox.communicationTypeId),
            text: checkbox.label.replaceAll(/<\/?[^>]+(>|$)/gi, ""),
            value: false
        };
    })), 2), commConsent = _useState5[0], setCommConsent = _useState5[1];
    var _useState6 = _sliced_to_array(useState({}), 2), formData = _useState6[0], setFormData = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), IP = _useState7[0], setIP = _useState7[1];
    var dataFields = [];
    var _useState8 = _sliced_to_array(useState({}), 2), queryParams = _useState8[0], setQueryParams = _useState8[1];
    function fetchIP() {
        return _fetchIP.apply(this, arguments);
    }
    function _fetchIP() {
        _fetchIP = // Get IP address from client for Hubspot analytics
        _async_to_generator(function() {
            var res;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://ip.nf/me.json")
                        ];
                    case 1:
                        res = _state.sent();
                        res.json().then(function(res) {
                            return setIP(res.ip.ip);
                        }).catch(function(err) {
                            return console.log(err);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchIP.apply(this, arguments);
    }
    useEffect(function() {
        fetchIP();
        if (props.formFieldGroups) {
            props.formFieldGroups.map(function(group) {
                var customFields = group.fields.map(function(field) {
                    return {
                        name: field.name,
                        value: field.value
                    };
                });
                dataFields.concat(customFields);
            });
        }
        if (typeof window !== "undefined") {
            setPageHref(window.location.href);
            setPageTitle(document.title);
        }
        //  Get and set query params, used to populate hidden fields
        var searchParams = new URLSearchParams(window.location.search);
        var params = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                params[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setQueryParams(params);
    // @eslint-disable-next-line
    }, []);
    var handleCommConsentChange = function(e) {
        var subscriptionTypeId = e.target.attributes["data-comm-id"].value;
        var value = e.target.checked;
        var text = e.target.attributes["data-text"].value;
        var updatedConsent = commConsent;
        // Find the field that's changed in dataFields and update the value
        var fieldIndex = commConsent.findIndex(function(field) {
            return field.subscriptionTypeId === subscriptionTypeId;
        });
        if (fieldIndex > -1) {
            updatedConsent[fieldIndex].value = value;
            updatedConsent[fieldIndex].text = text;
            setCommConsent(updatedConsent);
        } else {
            updatedConsent.push({
                subscriptionTypeId: subscriptionTypeId,
                value: value,
                text: text
            });
        }
    };
    var handleSubmit = function(e) {
        setFormSubmitting(true);
        e.preventDefault();
        if (props.enableTokenRedirect) {
            submitToHubspot(e, function() {
                return fetch("/edge-functions/create-token").then(function(res) {
                    return res;
                }).then(function(res) {
                    return res.json();
                }).then(function() {
                    var _ref = _async_to_generator(function(response) {
                        return _ts_generator(this, function(_state) {
                            // Set token for parent caller
                            return [
                                2,
                                response.hash
                            ];
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }()).catch(function(error) {
                    return console.log("error: ", error);
                });
            });
        } else {
            // normal submit without token creation
            submitToHubspot(e);
        }
    };
    var submitToHubspot = function(e, callback) {
        var url = "https://api.hsforms.com/submissions/v3/integration/submit/".concat(props.portalId, "/").concat(props.id);
        // hsCookie gets the data necessary to track Hubspot analytics
        var hsCookie = document.cookie.split(";").reduce(function(cookies, cookie) {
            var _cookie_split_map = _sliced_to_array(cookie.split("=").map(function(c) {
                return c.trim();
            }), 2), name = _cookie_split_map[0], value = _cookie_split_map[1];
            cookies[name] = value;
            return cookies;
        }, {});
        var formData = new FormData(e.target);
        var formProps = Object.fromEntries(formData);
        var data = {
            fields: Object.keys(formProps).map(function(name) {
                return {
                    name: name,
                    value: formProps[name]
                };
            }).filter(function(field) {
                return field.value && field.value !== "_none" && !field.name.startsWith("LEGAL_CONSENT");
            }),
            context: {
                hutk: hsCookie.hubspotutk,
                pageUri: props.pageUri || pageHref,
                pageName: props.pageName || pageTitle,
                ipAddress: "".concat(IP)
            },
            legalConsentOptions: {
                consent: {
                    consentToProcess: consentToProcess,
                    text: consentToProcess === true ? "I consent" : "I do not consent",
                    communications: commConsent
                }
            }
        };
        fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function(res) {
            return res.json();
        }).then(function() {
            var _ref = _async_to_generator(function(response) {
                var token;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!response.redirectUri) return [
                                3,
                                3
                            ];
                            if (!callback) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                callback()
                            ];
                        case 1:
                            token = _state.sent();
                            _state.label = 2;
                        case 2:
                            // Use window.location to set the new URL
                            // @TODO remove string
                            window.location.href = "".concat(response.redirectUri).concat(token ? "?token=".concat(token) : "");
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (props.inlineMessage) {
                                setIsSubmitted(true);
                            }
                            _state.label = 4;
                        case 4:
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).catch(function(error) {
            return console.log("error: ", error);
        });
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isSubmitted && props.inlineMessage ? /*#__PURE__*/ React.createElement(CtaShape, {
        inlineMessage: props.inlineMessage
    }) : "", props.formFieldGroups && !isSubmitted ? /*#__PURE__*/ React.createElement("form", {
        className: props.formClass || "hb-form font-sans",
        onSubmit: handleSubmit
    }, props.formFieldGroups && /*#__PURE__*/ React.createElement("div", {
        className: "pb-1"
    }, props.formFieldGroups.map(function(group, index) {
        var _group_fields_;
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: clsx((props === null || props === void 0 ? void 0 : props.divClass) || "mb-4", {
                hidden: ((_group_fields_ = group.fields[0]) === null || _group_fields_ === void 0 ? void 0 : _group_fields_.hidden) || !group.fields.length,
                "flex gap-x-4": group.fields.length > 1
            })
        }, group.fields.map(function(field, index) {
            return /*#__PURE__*/ React.createElement(Fragment, {
                key: index
            }, /*#__PURE__*/ React.createElement(HubspotFormField, {
                field: field,
                inputClass: props.inputClass,
                setFormData: setFormData,
                formData: formData,
                queryParams: queryParams
            }), field.dependentFieldFilters && /*#__PURE__*/ React.createElement(React.Fragment, null, field.dependentFieldFilters.map(function(childField, index) {
                var _formData_field_name;
                return /*#__PURE__*/ React.createElement(Fragment, {
                    key: index
                }, ((_formData_field_name = formData[field.name]) === null || _formData_field_name === void 0 ? void 0 : _formData_field_name.includes(childField.filters[0].strValues[0])) && /*#__PURE__*/ React.createElement("div", {
                    className: "mt-4"
                }, /*#__PURE__*/ React.createElement(HubspotFormField, {
                    field: childField.dependentFormField,
                    inputClass: props.inputClass,
                    setFormData: setFormData,
                    formData: formData,
                    queryParams: queryParams
                })));
            })));
        }));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "text-[#888]"
    }, legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : (_legalConsentOptions_communicationConsentCheckboxes1 = legalConsentOptions.communicationConsentCheckboxes) === null || _legalConsentOptions_communicationConsentCheckboxes1 === void 0 ? void 0 : _legalConsentOptions_communicationConsentCheckboxes1.map(function(checkbox, index) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-x-4 text-xxs mb-2",
            key: index
        }, /*#__PURE__*/ React.createElement("input", {
            type: "checkbox",
            name: "LEGAL_CONSENT.subscription_type_".concat(checkbox.communicationTypeId),
            id: "LEGAL_CONSENT.subscription_type_".concat(checkbox.communicationTypeId),
            "data-comm-id": checkbox.communicationTypeId,
            "data-text": checkbox.label.replaceAll(/<\/?[^>]+(>|$)/gi, ""),
            onChange: handleCommConsentChange
        }), /*#__PURE__*/ React.createElement("label", {
            htmlFor: "LEGAL_CONSENT.subscription_type_".concat(checkbox.communicationTypeId)
        }, /*#__PURE__*/ React.createElement("div", {
            className: "strong-underline",
            dangerouslySetInnerHTML: {
                __html: checkbox.label
            }
        })));
    }), legalConsentOptions && (legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : legalConsentOptions.processingConsentType) == "REQUIRED_CHECKBOX" && /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-x-4 text-xxs mb-2"
    }, /*#__PURE__*/ React.createElement("input", {
        type: "checkbox",
        id: "LEGAL_CONSENT.processing",
        name: "LEGAL_CONSENT.processing",
        onChange: function(e) {
            return setConsentToProcess(e.target.checked);
        },
        required: true
    }), /*#__PURE__*/ React.createElement("label", {
        htmlFor: "LEGAL_CONSENT.processing"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "strong-underline",
        dangerouslySetInnerHTML: {
            __html: legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : legalConsentOptions.processingConsentCheckboxLabel.replace(/<\/p>/, " *</p>")
        }
    }))), legalConsentOptions && (legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : legalConsentOptions.privacyPolicyText) && /*#__PURE__*/ React.createElement("div", {
        className: "text-xxs strong-underline",
        dangerouslySetInnerHTML: {
            __html: legalConsentOptions === null || legalConsentOptions === void 0 ? void 0 : legalConsentOptions.privacyPolicyText
        }
    })), /*#__PURE__*/ React.createElement("button", {
        className: clsx(props.submitButtonClass || "hb-button"),
        id: props.submitButtonId,
        type: "submit",
        disabled: formSubmitting
    }, !formSubmitting ? props.submitText || "Submit" : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        role: "status",
        className: "w-full flex justify-center"
    }, /*#__PURE__*/ React.createElement("svg", {
        "aria-hidden": "true",
        className: "w-7 h-7 text-[#888] animate-spin fill-yellow-500",
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
        fill: "currentFill"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Loading...")), /*#__PURE__*/ React.createElement("p", null, props.submitMessage)))) : /*#__PURE__*/ React.createElement("em", null));
}
function CtaShape(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: 'px-6 overflow-hidden md:px-14 min-h-[340px] lg:min-h-[492px] lg:-mt-20 relative before:lg:content-[""] before:lg:block before:lg:absolute before:lg:top-0 before:lg:right-0 before:lg:w-1/2 before:lg:h-full'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "max-w-md mx-auto text-center relative z-10 pt-12 md:pt-16 lg:pt-60"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-xl md:text-3xl font-heading font-medium"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.inlineMessage
    })), /*#__PURE__*/ React.createElement("div", {
        className: "sm:flex gap-x-4 justify-center mt-9 lg:mt-12"
    }, " "))));
}
